<div class="card landing-card no-margin dashboard-icon-pad" (click)="moduleLink({'link': routeLink, 'extlink': externalLink})" >                          
	<div class="content text-center">
	  <div class="dashboard-icon">
		<img [src]="imageSrc" alt="{{title}}" title="{{title}}" >
	  </div>                            
	  <div class="title module-title dashboard-item-title">
		<a *ngIf="routeLink" [routerLink]=[routeLink]>
			{{title | translate}}
			</a>
			<a *ngIf="externalLink" href="{{externalLink}}" target="_blank" (click)="$event.stopPropagation()">
			{{title | translate}}
			</a>
	  </div>
	  <div class="module-desc dashboard-item-subtitle marT5">{{description| translate}}</div>
	</div>
</div>

<lib-modalform
    modalClass="support"
    modalID="support"
    [viewType]="'add'"
    [modalTitle]="'Contact Support'"
    [btnCancelText]="'Ok'"
    (cancelEvent)="''">
    <div class="modalBody pad20">
		<div class="padT10">

            <label class="form-title" >
				{{'Contact support' | translate}}
            </label>
		</div>
		<div class="modal-body padT10">
			<div class="modal-text">
				
				<p class="text2" [ngClass]="textDir=='ltr'?'pull-left':'pull-right'">
					{{'If you are experiencing technical issues please email a description of your issue to' | translate}} <a href="mailto:connecttolearn@ericsson.com">
						connecttolearn@ericsson.com </a>


				</p>
				
			</div>
		</div>
    </div>
</lib-modalform>